<template>
    <div>
        <loading
            :active.sync="loading"
            :can-cancel="false"
            :is-full-page="true"
            :height="150"
            :width="150"
            :color="'#FFFF00'"
            :background-color="'#000000'"
            :opacity="0.5"
        ></loading>
        <v-container>
            <v-form>
                <v-row>
                    <h2 class="pb-5">{{ this.pageTitle }}</h2>
                </v-row>

                <v-row>
                    <div class="pb-5 pl-4">
                        <v-btn 
                            color="warning" 
                            style="width: 100px" 
                            @click="backHandler"> 
                            {{$t('button.back')}}
                        </v-btn>
                    </div>
                </v-row>
                
                <v-container
                    id="scroll-target"
                    class="custom-form overflow-y-auto px-5"
                >

                <v-row>
                    <v-col>
                    <v-toolbar flat>
                        <v-toolbar-title>{{$t('payrolldashboardreport.payrollsummaryfor')}} <span class="blue--text"> {{data.formData.pyyear}}/{{data.formData.pymonth}} </span></v-toolbar-title>
                    </v-toolbar>
                    <v-card elevation="2" rounded="lg" style="border:1px solid #E8EDF5;overflow:hidden;">
                        <div style="background:linear-gradient(135deg,#4F6BFF 0%,#7C3AFF 100%);height:4px;"></div>
                        <div class="ma-4">
                            <v-row>
                                <v-col class="pb-n4 mb-n8 mr-n3">
                                    <div class="db-stat-card db-stat-blue">
                                        <div class="db-stat-label">{{$t('reportsparam.year')}}</div>
                                        <div class="db-stat-value">{{data.formData.pyyear}}</div>
                                    </div>
                                </v-col>

                                <v-col class="pb-n4 mb-n8 mr-n3">
                                    <div class="db-stat-card db-stat-blue">
                                        <div class="db-stat-label">{{$t('reportsparam.month')}}</div>
                                        <div class="db-stat-value">{{data.formData.pymonth}}</div>
                                    </div>
                                </v-col>

                                <v-col cols="2" class="pb-n4 mb-n8 mr-n3">
                                    <div class="db-stat-card db-stat-purple">
                                        <div class="db-stat-label">{{$t('reportsparam.payout')}}</div>
                                        <div class="db-stat-value db-stat-value-sm">{{payoutname}}</div>
                                    </div>
                                </v-col>

                                <v-col cols="3" class="pb-n5 mr-n3">
                                    <div class="db-stat-card db-stat-green">
                                        <div class="db-stat-label">{{$t('payrolldashboardreport.totalpaid')}}</div>
                                        <div class="db-stat-value">{{payoutDetail.totalpaid}}</div>
                                    </div>
                                </v-col>

                                <v-col cols="2" class="pb-n5 mr-n3">
                                    <div class="db-stat-card db-stat-indigo">
                                        <div class="db-stat-label">{{$t('payrolldashboardreport.paxprocessed')}}</div>
                                        <div class="db-stat-value">{{totalStaff}}</div>
                                    </div>
                                </v-col>

                                <v-col cols="2" class="pb-n5">
                                    <div class="db-stat-card db-stat-orange">
                                        <div class="db-stat-label">N | A | R</div>
                                        <div class="db-nar-row">
                                            <span class="db-nar-item db-nar-new">{{newJoiner}}</span>
                                            <span class="db-nar-sep">|</span>
                                            <span class="db-nar-item db-nar-active">{{availableStaff}}</span>
                                            <span class="db-nar-sep">|</span>
                                            <span class="db-nar-item db-nar-resign">{{resignStaff}}</span>
                                        </div>
                                    </div>
                                </v-col>
                            </v-row>

                            <v-row class="pt-10">
                                <v-col cols="4" sm="4" class="pb-n4 mt-n8">
                                    <div class="db-amount-card db-amount-primary">
                                        <div class="db-amount-label">{{$t('previewpayroll.grosspay')}}</div>
                                        <div class="db-amount-value">{{ dashboardItems.grossPay }}</div>
                                    </div>
                                </v-col>
                                <v-col cols="4" sm="4" class="pb-n4 mt-n8">
                                    <div class="db-amount-card db-amount-success">
                                        <div class="db-amount-label">{{$t('previewpayroll.netpay')}}</div>
                                        <div class="db-amount-value">{{ dashboardItems.netPay }}</div>
                                    </div>
                                </v-col>
                                <v-col cols="4" sm="4" class="pb-n4 mt-n8">
                                    <div class="db-amount-card db-amount-purple">
                                        <div class="db-amount-label">{{$t('payrolldashboardreport.companyfringe')}}</div>
                                        <div class="db-amount-value">{{ dashboardItems.companyFringe }}</div>
                                    </div>
                                </v-col>
                            </v-row>

                            <v-row>
                                <v-col cols="4" sm="4" class="pb-n4 mt-n8">
                                    <div class="db-amount-card db-amount-primary">
                                        <div class="db-amount-label">{{$t('payrolldashboardreport.basic')}}</div>
                                        <div class="db-amount-value">{{ dashboardItems.basic }}</div>
                                    </div>
                                </v-col>
                                <v-col cols="4" sm="4" class="pb-n4 mt-n8">
                                    <div class="db-amount-card db-amount-teal">
                                        <div class="db-amount-label">{{$t('payrolldashboardreport.allowance')}}</div>
                                        <div class="db-amount-value">{{ dashboardItems.allowance }}</div>
                                    </div>
                                </v-col>
                                <v-col cols="4" sm="4" class="pb-n4 mt-n8">
                                    <div class="db-amount-card db-amount-teal">
                                        <div class="db-amount-label">{{$t('payrolldashboardreport.reimbursement')}}</div>
                                        <div class="db-amount-value">{{ dashboardItems.reimbursement }}</div>
                                    </div>
                                </v-col>
                            </v-row>

                            <v-row>
                                <v-col cols="4" sm="4" class="pb-n4 mt-n8">
                                    <div class="db-amount-card db-amount-orange">
                                        <div class="db-amount-label">{{$t('payrolldashboardreport.overtime')}}</div>
                                        <div class="db-amount-value">{{ dashboardItems.overtime }}</div>
                                    </div>
                                </v-col>
                                <v-col cols="4" sm="4" class="pb-n4 mt-n8">
                                    <div class="db-amount-card db-amount-orange">
                                        <div class="db-amount-label">{{$t('payrolldashboardreport.bonus')}}</div>
                                        <div class="db-amount-value">{{ dashboardItems.bonus }}</div>
                                    </div>
                                </v-col>
                                <v-col cols="4" sm="4" class="pb-n4 mt-n8">
                                    <div class="db-amount-card db-amount-red">
                                        <div class="db-amount-label">{{$t('payrolldashboardreport.generaldeductions')}}</div>
                                        <div class="db-amount-value">{{ dashboardItems.generalDeductions }}</div>
                                    </div>
                                </v-col>
                            </v-row>

                            <v-row>
                                <v-col cols="4" sm="4" class="pb-n4 mt-n8">
                                    <div class="db-amount-card db-amount-red">
                                        <div class="db-amount-label">{{$t('payrolldashboardreport.staffstatutorydeductions')}}</div>
                                        <div class="db-amount-value">{{ dashboardItems.staffStatutoryDeductions }}</div>
                                    </div>
                                </v-col>
                                <v-col cols="4" sm="4" class="pb-n4 mt-n8">
                                    <div class="db-amount-card db-amount-red">
                                        <div class="db-amount-label">{{$t('payrolldashboardreport.companystatutorydeductions')}}</div>
                                        <div class="db-amount-value">{{ dashboardItems.companyStatutoryDeductions }}</div>
                                    </div>
                                </v-col>
                            </v-row>

                        </div>
                    </v-card>
                    </v-col>
                </v-row>

                <v-row class="mt-n2 mb-n4 pl-4">
                    <v-col>
                        {{$t('payrolldashboardreport.view')}} <span @click="goToDetail" class="blue--text"> {{$t('payrolldashboardreport.details')}}</span>
                    </v-col>
                </v-row>

                <v-row class="mt-n6 mb-n6"></v-row>

                <div v-for="det in detailItems" :key="det.id">
                <v-row>
                    <v-col col="12" sm="12" class="pb4-4 mt-8">
                        <v-data-table
                            :headers="tabHeader"
                            class="elavation-1"
                            fixed-header
                            :sort-by="['code']"
                            :options="tableOpt"
                            hide-default-footer
                        >
                        <template v-slot:top>
                            <v-toolbar flat>
                                <v-toolbar-title>{{$t('payrolldashboardreport.payrollsummaryfor')}}  <span class="blue--text"> {{data.formData.pyyear}}/{{data.formData.pymonth}}  </span> 
                                <div class="subtitle-2 blue--text">{{det[0].compnydesc}}</div>
                                </v-toolbar-title>
                                <v-spacer></v-spacer>

                                <button type="button" class="export-icon-btn export-icon-pdf" @click="printPDF(det)" title="Export PDF">
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><path d="M9 13h2a2 2 0 0 1 0 4H9v-4z"/><path d="M15 13h1a2 2 0 0 1 0 4h-1"/><line x1="15" y1="17" x2="17" y2="17"/></svg>
              PDF
            </button>

                                <button type="button" class="export-icon-btn export-icon-csv" @click="getCSV(det)" title="Export CSV">
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="12" y1="18" x2="12" y2="12"/><polyline points="9 15 12 18 15 15"/></svg>
              CSV
            </button>
                                
                            </v-toolbar>
                        </template>
                        <template v-slot:body>
                            <tbody>
                                <tr v-for="item in det.slice(0,-1)" :key="item.id">
                                    <td >
                                        {{item.no}}
                                    </td>
                                    <td >
                                        {{item.payItemType}}
                                    </td>
                                    <td >
                                        {{item.payItem}}
                                    </td>
                                    <td >
                                        {{item.amount}}
                                    </td>
                                    <td >
                                        {{item.subTotal}}
                                    </td>
                                </tr>
                                <!-- <tr class="total">
                                    <td></td>
                                    <td></td>
                                    <td class="text-right">Total</td>
                                    <td>{{det[det.length-1].totalamt}}</td>
                                    <td>{{det[det.length-1].totalsubTotal}}</td>
                                </tr> -->
                            </tbody>
                        </template>
                        </v-data-table>
                    </v-col>
                </v-row>
                </div>
                
                </v-container>

            </v-form>
        </v-container>
    </div>
</template>

<script>
import jsPDF from 'jspdf'
import 'jspdf-autotable'
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

export default {
    components: {
        Loading,
    },

    data() {
        return {
            publicPath: process.env.BASE_URL,
            rules: {
                required: value => !!value || this.$t('reportsparam.required'),
                email: value => {
                    const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                    return pattern.test(value) || 'Invalid e-mail.'
                }
            },
            pageTitle: 'Payroll Dashboard Detail',
            tableTitle: this.$route.params.formData.pyyear + '_' + this.$route.params.formData.pymonth,

            data: {
                formData: {
                    pyyear: this.$route.params.formData.pyyear,
                    pymonth: this.$route.params.formData.pymonth,
                    poid: this.$route.params.formData.poid,
                },

                parameters: {
                    brchid: this.$route.params.param.brchid,
                    compnyid: this.$route.params.param.compnyid,
                    deptid: this.$route.params.param.deptid,
                    emptypeid: this.$route.params.param.emptypeid,
                    gradeid: this.$route.params.param.gradeid,
                    staffid: this.$route.params.param.staffid,
                },
            },
            
            dashboardItemsHolder: {
                grossPay: null,
                netPay: null,
                companyFringe: null,
                basic: null,
                allowance: null,
                reimbursement: null,
                overtime: null,
                bonus: null,
                generalDeductions: null,
                staffStatutoryDeductions: null,
                companyStatutoryDeductions: null,
            },

            payoutDetail: {
                totalpaid: null,
            },

            dashboardItems: {
                grossPay: null,
                netPay: null,
                companyFringe: null,
                basic: null,
                allowance: null,
                reimbursement: null,
                overtime: null,
                bonus: null,
                generalDeductions: null,
                staffStatutoryDeductions: null,
                companyStatutoryDeductions: null,
            },

            payoutname: null,
            totalStaff: null,
            availableStaff: null,
            newJoiner: null,
            resignStaff: null,

            options: {
                plotOptions: {
                    bar: {
                        distributed: true
                    }
                },
                xaxis: {
                    categories: [],
                    title: {
                        text: this.$t('columns.company')
                    }
                },
                yaxis: {
                    title: {
                        text: this.$t('setuppersonpayrolldirectassignment.amount')
                    },
                },
                title: {
                    text: this.$t('payrolldashboardreport.totalpaidoutbycompany')
                },
            },
            series: [{
                data: []
            }],

            tpbc: [],
            tpbch: [],
            
            tableOpt: {
                itemsPerPage: -1
            },
            title: null,
            detailItems: [],
            itemData: {
                itemcode: null,
                itemdesc: null,
                itemstamp: 0
            },
            tabHeader: [
                { text: this.$t('columns.no'), value: 'no', sortable: false, width: '5px' },
                { text: this.$t('setuppayitmetype.payitemtype'), value: 'payItemType', width: '50px', sortable: false},
                { text: this.$t('setuppayitem.payitem'), value: 'payItem', width: '200px', sortable: false },
                { text: this.$t('setuppersonpayrolldirectassignment.amount'), value: 'amount', sortable: false, width: '5px' },
                { text: this.$t('payrolldashboardreport.subtotal'), value: 'subTotal', width: '50px', sortable: false},
            ],
            
            amountTotal: null,
            subTotal: null,

            errMsg: '',
            isErr: false,
            loading: false,
        }
    },

    methods: {

        totalPaid() {
            return new Promise((resolve) => {
                setTimeout(() => {
                    const vm = this;
    
                    let totalpaidholder = [
                        vm.dashboardItemsHolder.netPay,
                        vm.dashboardItemsHolder.companyFringe,
                        vm.dashboardItemsHolder.staffStatutoryDeductions,
                        vm.dashboardItemsHolder.companyStatutoryDeductions,
                    ]
    
                    let totalpaidsum = totalpaidholder.reduce(function(a, b) {
                        return a + b;
                    }, 0);
    
                    vm.payoutDetail.totalpaid = 'RM ' + totalpaidsum.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");

                    resolve();
                }, 1000);
            });
        },

        loadPayoutControl() {
            const vm = this;

            return this.$store.dispatch('get', {url: "/payoutctrl/" + vm.data.formData.poid})
            .then((res) => {
                
                let payout = res.data.rec[0];
                vm.payoutname = payout.payoutdesc
                vm.data.formData.pyyear = payout.pyyear
                vm.data.formData.pymonth = payout.pymonth
            })
            .catch((err) => {
                vm.isErr = !vm.isErr;
                vm.errMsg = err;
            });
        },

        loadNewJoiner() {
            const vm = this;

            //this.$store.dispatch('post', {url: '/payrolldashboard/grosspay', payload: this.data})
            return this.$store.dispatch('post', {url: `/payrolldashboard/newjoiner/${this.$store.getters.userId}`, payload: this.data})
            .then(function (res) {
                let newJoinerHolder = res.data.rec;
                vm.newJoiner = newJoinerHolder.length
            })
            .catch(err => {
                vm.isErr = true;
                vm.errMsg = err;
                vm.$emit('error', {isErr: vm.isErr, errMsg: vm.errMsg});
            });
        },

        loadResign() {
            const vm = this;
            
            //this.$store.dispatch('post', {url: '/payrolldashboard/grosspay', payload: this.data})
            return this.$store.dispatch('post', {url: `/payrolldashboard/resign/${this.$store.getters.userId}`, payload: this.data})
            .then(function (res) {
                let resignHolder = res.data.rec;
                vm.resignStaff = resignHolder.length
            })
            .catch(err => {
                vm.isErr = true;
                vm.errMsg = err;
                vm.$emit('error', {isErr: vm.isErr, errMsg: vm.errMsg});
            });
            
        },

        loadTotalStaff() {
            const vm = this;

            //this.$store.dispatch('post', {url: '/payrolldashboard/grosspay', payload: this.data})
            return this.$store.dispatch('post', {url: `/payrolldashboard/totalstaff/${this.$store.getters.userId}`, payload: this.data})
            .then(function (res) {
                let totalStaffHolder = res.data.rec;
                vm.totalStaff = totalStaffHolder.length
            })
            .catch(err => {
                vm.isErr = true;
                vm.errMsg = err;
                vm.$emit('error', {isErr: vm.isErr, errMsg: vm.errMsg});
            });
        
        },

        loadAvailableStaff() {
            const vm = this;
            return vm.availableStaff = vm.totalStaff - vm.newJoiner - vm.resignStaff
        },

        async loadDelay() {
            await new Promise(resolve => setTimeout(resolve, 300));
            await this.loadNewJoiner();
            await this.loadResign();

            await new Promise(resolve => setTimeout(resolve, 800));
            await this.totalPaid();
            await this.loadAvailableStaff();
        },


        loadGrossPay() {
            const vm = this;

            //this.$store.dispatch('post', {url: '/payrolldashboard/grosspay', payload: this.data})
            return this.$store.dispatch('post', {url: `/payrolldashboard/grosspay/${this.$store.getters.userId}`, payload: this.data})
            .then(function (res) {
                if (res.data.rec.length > 0) {
                    let grossPay = res.data.rec;
                    let grossPayHolder = []

                    grossPay.forEach(element => {
                        grossPayHolder.push(parseFloat(element.grosspayamount.replace(/,/g, '')))
                    });

                    vm.dashboardItemsHolder.grossPay = grossPayHolder.reduce(function(a, b) {
                        return a + b;
                    }, 0);

                    vm.dashboardItems.grossPay = 'RM ' + vm.dashboardItemsHolder.grossPay.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")

                } else {
                    vm.dashboardItemsHolder.grossPay = 0
                    vm.dashboardItems.grossPay =  'RM 0.00'
                }
            })
            .catch(err => {
                vm.isErr = true;
                vm.errMsg = err;
                vm.$emit('error', {isErr: vm.isErr, errMsg: vm.errMsg});
            });
        },

        loadNetPay() {
            const vm = this;

            //this.$store.dispatch('post', {url: '/payrolldashboard/netpay', payload: this.data})
            return this.$store.dispatch('post', {url: `/payrolldashboard/netpay/${this.$store.getters.userId}`, payload: this.data})
            .then(function (res) {
                if (res.data.rec.length > 0) {
                    let netPay = res.data.rec;
                    let netPayHolder = []

                    netPay.forEach(element => {
                        netPayHolder.push(parseFloat(element.netpayamount.replace(/,/g, '')))
                        vm.tpbch.push(element.compnydesc)
                        vm.tpbc.push(element)
                    });

                    vm.dashboardItemsHolder.netPay = netPayHolder.reduce(function(a, b) {
                        return a + b;
                    }, 0);

                    vm.dashboardItems.netPay = 'RM ' + vm.dashboardItemsHolder.netPay.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")

                } else {
                    vm.dashboardItemsHolder.netPay = 0
                    vm.dashboardItems.netPay =  'RM 0.00'
                }
            })
            .catch(err => {
                vm.isErr = true;
                vm.errMsg = err;
                vm.$emit('error', {isErr: vm.isErr, errMsg: vm.errMsg});
            });
        },

        loadCompanyFringe() {
            const vm = this;

            //this.$store.dispatch('post', {url: '/payrolldashboard/companyfringe ', payload: this.data})
            return this.$store.dispatch('post', {url: `/payrolldashboard/companyfringe/${this.$store.getters.userId}`, payload: this.data})
            .then(function (res) {
                if (res.data.rec.length > 0) {
                    let companyFringe = res.data.rec;
                    let companyFringeHolder = []

                    companyFringe.forEach(element => {
                        companyFringeHolder.push(parseFloat(element.companyfringe.replace(/,/g, '')))
                        vm.tpbch.push(element.compnydesc)
                        vm.tpbc.push(element)
                    });

                    vm.dashboardItemsHolder.companyFringe = companyFringeHolder.reduce(function(a, b) {
                        return a + b;
                    }, 0);

                    vm.dashboardItems.companyFringe = 'RM ' + vm.dashboardItemsHolder.companyFringe.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    
                } else {
                    vm.dashboardItemsHolder.companyFringe = 0
                    vm.dashboardItems.companyFringe =  'RM 0.00'
                }
            })
            .catch(err => {
                vm.isErr = true;
                vm.errMsg = err;
                vm.$emit('error', {isErr: vm.isErr, errMsg: vm.errMsg});
            });
        },

        loadBasic() {
            const vm = this;

            //this.$store.dispatch('post', {url: '/payrolldashboard/basic', payload: this.data})
            return this.$store.dispatch('post', {url: `/payrolldashboard/basic/${this.$store.getters.userId}`, payload: this.data})
            .then(function (res) {
                if (res.data.rec.length > 0) {
                    let basic = res.data.rec;
                    let basicHolder = []

                    basic.forEach(element => {
                        basicHolder.push(parseFloat(element.basicamount.replace(/,/g, '')))
                    });

                    vm.dashboardItemsHolder.basic = basicHolder.reduce(function(a, b) {
                        return a + b;
                    }, 0);

                    vm.dashboardItems.basic = 'RM ' + vm.dashboardItemsHolder.basic.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    
                } else {
                    vm.dashboardItemsHolder.basic = 0
                    vm.dashboardItems.basic =  'RM 0.00'
                }
            })
            .catch(err => {
                vm.isErr = true;
                vm.errMsg = err;
                vm.$emit('error', {isErr: vm.isErr, errMsg: vm.errMsg});
            });
        },

        loadAllowance() {
            const vm = this;

            //this.$store.dispatch('post', {url: '/payrolldashboard/allowance', payload: this.data})
            return this.$store.dispatch('post', {url: `/payrolldashboard/allowance/${this.$store.getters.userId}`, payload: this.data})
            .then(function (res) {
                if (res.data.rec.length > 0) {
                    let allowance = res.data.rec;
                    let allowanceHolder = []

                    allowance.forEach(element => {
                        allowanceHolder.push(parseFloat(element.allowanceamount.replace(/,/g, '')))
                    });

                    vm.dashboardItemsHolder.allowance = allowanceHolder.reduce(function(a, b) {
                        return a + b;
                    }, 0);

                    vm.dashboardItems.allowance = 'RM ' + vm.dashboardItemsHolder.allowance.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    
                } else {
                    vm.dashboardItemsHolder.allowance = 0
                    vm.dashboardItems.allowance =  'RM 0.00'
                }
            })
            .catch(err => {
                vm.isErr = true;
                vm.errMsg = err;
                vm.$emit('error', {isErr: vm.isErr, errMsg: vm.errMsg});
            });
        },

        loadReimbursement() {
            const vm = this;

            //this.$store.dispatch('post', {url: '/payrolldashboard/reimbursement', payload: this.data})
            return this.$store.dispatch('post', {url: `/payrolldashboard/reimbursement/${this.$store.getters.userId}`, payload: this.data})
            .then(function (res) {
                if (res.data.rec.length > 0) {
                    let reimbursement = res.data.rec;
                    let reimbursementHolder = []

                    reimbursement.forEach(element => {
                        reimbursementHolder.push(parseFloat(element.reimbursementamount.replace(/,/g, '')))
                    });

                    vm.dashboardItemsHolder.reimbursement = reimbursementHolder.reduce(function(a, b) {
                        return a + b;
                    }, 0);

                    vm.dashboardItems.reimbursement = vm.dashboardItemsHolder.reimbursement.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    
                } else {
                    vm.dashboardItemsHolder.reimbursement = 0
                    vm.dashboardItems.reimbursement =  '0.00'
                }
            })
            .catch(err => {
                vm.isErr = true;
                vm.errMsg = err;
                vm.$emit('error', {isErr: vm.isErr, errMsg: vm.errMsg});
            });
        },

        loadOvertime() {
            const vm = this;

            //this.$store.dispatch('post', {url: '/payrolldashboard/overtime', payload: this.data})
            return this.$store.dispatch('post', {url: `/payrolldashboard/overtime/${this.$store.getters.userId}`, payload: this.data})
            .then(function (res) {
                if (res.data.rec.length > 0) {
                    let overtime = res.data.rec;
                    let overtimeHolder = []

                    overtime.forEach(element => {
                        overtimeHolder.push(parseFloat(element.overtimeamount.replace(/,/g, '')))
                    });

                    vm.dashboardItemsHolder.overtime = overtimeHolder.reduce(function(a, b) {
                        return a + b;
                    }, 0);

                    vm.dashboardItems.overtime = 'RM ' + vm.dashboardItemsHolder.overtime.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    
                } else {
                    vm.dashboardItemsHolder.overtime = 0
                    vm.dashboardItems.overtime =  'RM 0.00'
                }
            })
            .catch(err => {
                vm.isErr = true;
                vm.errMsg = err;
                vm.$emit('error', {isErr: vm.isErr, errMsg: vm.errMsg});
            });
        },

        loadBonus() {
            const vm = this;

            //this.$store.dispatch('post', {url: '/payrolldashboard/bonus', payload: this.data})
            return this.$store.dispatch('post', {url: `/payrolldashboard/bonus/${this.$store.getters.userId}`, payload: this.data})
            .then(function (res) {
                if (res.data.rec.length > 0) {
                    let bonus = res.data.rec;
                    let bonusHolder = []

                    bonus.forEach(element => {
                        bonusHolder.push(parseFloat(element.bonusamount.replace(/,/g, '')))
                    });

                    vm.dashboardItemsHolder.bonus = bonusHolder.reduce(function(a, b) {
                        return a + b;
                    }, 0);

                    vm.dashboardItems.bonus = 'RM ' + vm.dashboardItemsHolder.bonus.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    
                } else {
                    vm.dashboardItemsHolder.bonus = 0
                    vm.dashboardItems.bonus =  'RM 0.00'
                }
            })
            .catch(err => {
                vm.isErr = true;
                vm.errMsg = err;
                vm.$emit('error', {isErr: vm.isErr, errMsg: vm.errMsg});
            });
        },

        loadGeneralDeduction() {
            const vm = this;

            //this.$store.dispatch('post', {url: '/payrolldashboard/generaldeduction', payload: this.data})
            return this.$store.dispatch('post', {url: `/payrolldashboard/generaldeduction/${this.$store.getters.userId}`, payload: this.data})
            .then(function (res) {
                if (res.data.rec.length > 0) {
                    let generalDeductions = res.data.rec;
                    let generalDeductionsHolder = []

                    generalDeductions.forEach(element => {
                        generalDeductionsHolder.push(parseFloat(element.generaldeduction.replace(/,/g, '')))
                    });

                    vm.dashboardItemsHolder.generalDeductions = generalDeductionsHolder.reduce(function(a, b) {
                        return a + b;
                    }, 0);

                    vm.dashboardItems.generalDeductions = 'RM ' + vm.dashboardItemsHolder.generalDeductions.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    
                } else {
                    vm.dashboardItemsHolder.generalDeductions = 0
                    vm.dashboardItems.generalDeductions =  'RM 0.00'
                }
            })
            .catch(err => {
                vm.isErr = true;
                vm.errMsg = err;
                vm.$emit('error', {isErr: vm.isErr, errMsg: vm.errMsg});
            });
        },

        loadStatutoryDeductionStaff() {
            const vm = this;

            //this.$store.dispatch('post', {url: '/payrolldashboard/statutorydeductionstaff', payload: this.data})
            return this.$store.dispatch('post', {url: `/payrolldashboard/statutorydeductionstaff/${this.$store.getters.userId}`, payload: this.data})
            .then(function (res) {
                if (res.data.rec.length > 0) {
                    let statutoryDeductionsStaff = res.data.rec;
                    let statutoryDeductionsStaffHolder = []

                    statutoryDeductionsStaff.forEach(element => {
                        statutoryDeductionsStaffHolder.push(parseFloat(element.statutorydeduction.replace(/,/g, '')))
                        vm.tpbch.push(element.compnydesc)
                        vm.tpbc.push(element)
                    });

                    vm.dashboardItemsHolder.staffStatutoryDeductions = statutoryDeductionsStaffHolder.reduce(function(a, b) {
                        return a + b;
                    }, 0);

                    vm.dashboardItems.staffStatutoryDeductions = 'RM ' + vm.dashboardItemsHolder.staffStatutoryDeductions.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    
                } else {
                    vm.dashboardItemsHolder.staffStatutoryDeductions = 0
                    vm.dashboardItems.staffStatutoryDeductions =  'RM 0.00'
                }
            })
            .catch(err => {
                vm.isErr = true;
                vm.errMsg = err;
                vm.$emit('error', {isErr: vm.isErr, errMsg: vm.errMsg});
            });
        },

        loadStatutoryDeductionCompany() {
            const vm = this;

            //this.$store.dispatch('post', {url: '/payrolldashboard/statutorydeductioncompany', payload: this.data})
            return this.$store.dispatch('post', {url: `/payrolldashboard/statutorydeductioncompany/${this.$store.getters.userId}`, payload: this.data})
            .then(function (res) {
                if (res.data.rec.length > 0) {
                    let statutoryDeductionsCompany = res.data.rec;
                    let statutoryDeductionsCompanyHolder = []

                    statutoryDeductionsCompany.forEach(element => {
                        statutoryDeductionsCompanyHolder.push(parseFloat(element.statutorydeduction.replace(/,/g, '')))
                        vm.tpbch.push(element.compnydesc)
                        vm.tpbc.push(element)
                    });

                    vm.dashboardItemsHolder.companyStatutoryDeductions = statutoryDeductionsCompanyHolder.reduce(function(a, b) {
                        return a + b;
                    }, 0);

                    vm.dashboardItems.companyStatutoryDeductions = 'RM ' + vm.dashboardItemsHolder.companyStatutoryDeductions.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    
                } else {
                    vm.dashboardItemsHolder.companyStatutoryDeductions = 0
                    vm.dashboardItems.companyStatutoryDeductions =  'RM 0.00'
                }
            })
            .catch(err => {
                vm.isErr = true;
                vm.errMsg = err;
                vm.$emit('error', {isErr: vm.isErr, errMsg: vm.errMsg});
            });
        },

        loadCompanyS() {
            const vm = this;

            //this.$store.dispatch('post', {url: '/payrolldashboard/summaryearning', payload: this.data})
            return this.$store.dispatch('post', {url: `/payrolldashboard/summaryearning/${this.$store.getters.userId}`, payload: this.data})
            .then(function (res) {
                let dataItemsCompanyS = res.data.rec;
                
                //let dataItemsCompanyHolder = res.data.rec;
                let getamount = []
                let getheader = []

                dataItemsCompanyS.forEach(function (o) {
                    var existing = getamount.filter(function (i) {
                        return i.payitemtypecode === o.payitemtypecode && i.compnydesc === o.compnydesc;
                    })[0];
                    if (!existing || existing == undefined) {
                        o.subTotal = parseFloat(o.amount.replace(/,/g, ''))
                        getamount.push(o);
                    } else {
                        o.payitemtypedesc = ''
                        existing.subTotal += parseFloat(o.amount.replace(/,/g, ''));
                    }
                    if (getheader.indexOf(o.compnydesc) === -1 ) getheader.push(o.compnydesc)
                });

                for (let i = 0; i < getheader.length; i++) {
                    let detholder = []
                    let totalamtholder = []
                    let totalsubTotalholder = []
                    let count = 1
                    for (let j = 0; j < dataItemsCompanyS.length; j++) {
                        if (dataItemsCompanyS[j].compnydesc == getheader[i]) {
                            if (dataItemsCompanyS[j].subTotal) {
                                dataItemsCompanyS[j].subTotal = dataItemsCompanyS[j].subTotal.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                                totalsubTotalholder.push(parseFloat(dataItemsCompanyS[j].subTotal.replace(/,/g, '')))
                            }
                            detholder.push({
                                no: count++,
                                compnydesc: dataItemsCompanyS[j].compnydesc,
                                payItemType: dataItemsCompanyS[j].payitemtypedesc,
                                payItem: dataItemsCompanyS[j].payitemdesc,
                                amount: dataItemsCompanyS[j].amount,
                                subTotal: dataItemsCompanyS[j].subTotal
                            })
                            totalamtholder.push(parseFloat(dataItemsCompanyS[j].amount.replace(/,/g, '')))
                            
                        }
                    }
                    let totalamt = totalamtholder.reduce(function(a, b) {
                        return a + b;
                    }, 0);

                    let totalsubTotal = totalsubTotalholder.reduce(function(a, b) {
                        return a + b;
                    }, 0);
                    
                    let totalholder = {
                        totalamt: totalamt.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","),
                        totalsubTotal: totalsubTotal.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }
                    
                    detholder.push(totalholder)
                    
                    vm.detailItems.push(detholder)
                }
            })
            .catch(function (err) {
                vm.errMsg = err;
            });
        },

        backHandler() {
            let formData = this.data.formData
            let param = this.data.parameters

            this.$router.push({name: 'payrolldashboardsummary', params: { formData, param }});
        },

        goToDetail() {
            let formData = this.data.formData
            let param = this.data.parameters

            this.$router.push({name: 'payrolldashboarddetail2', params: { formData, param }});
        },

        objectToCSV(data) {
            const csvRows = []

            // get header
            const headers = Object.keys(data[0])
            csvRows.push(headers.join(','))

            // loop over the rows
            for (const row of data) {
                const values = headers.map(header => {
                    const escaped = ('' + row[header]).replace(/"/g, '\\"')
                    return `"${escaped}"`
                })
                csvRows.push(values.join(','))
            }
            return csvRows.join('\n')
        },

        download(data) {
            const blob = new Blob([decodeURIComponent('%ef%bb%bf'), data], { type: 'text/csv'})
            const url = window.URL.createObjectURL(blob)
            const a = document.createElement('a')

            a.setAttribute('hidden', '')
            a.setAttribute('href', url)
            a.setAttribute('download', this.$t('payrolldashboardreport.payrollsummaryfor'), + this.tableTitle + '.csv')

            document.body.appendChild(a)
            a.click()
            document.body.removeChild(a)
        },

        async getCSV(item) {
            let itemBasic = item
            let data = []

            for (var i = 0; i < itemBasic.length - 1; i++) {
                let subTotalholder = ''
                if (itemBasic[i].subTotal) subTotalholder = item[i].subTotal
                data.push({
                    [`${this.$t('columns.no')}`]: itemBasic[i].no,
                    [`${this.$t('setuppayitmetype.payitemtype')}`]: itemBasic[i].payItemType,
                    [`${this.$t('setuppayitem.payitem')}`]: itemBasic[i].payItem,
                     [`${this.$t('setuppersonpayrolldirectassignment.amount')}`]: itemBasic[i].amount,
                     [`${this.$t('payrolldashboardreport.subtotal')}`]: subTotalholder,
                })
            }

            data.push({
                [`${this.$t('columns.no')}`]: '',
                [`${this.$t('setuppayitmetype.payitemtype')}`]: '',
                [`${this.$t('setuppayitem.payitem')}`]: 'Total',
                 [`${this.$t('setuppersonpayrolldirectassignment.amount')}`]: itemBasic[itemBasic.length-1].totalamt,
                 [`${this.$t('payrolldashboardreport.subtotal')}`]: itemBasic[itemBasic.length-1].totalsubTotal,
            })

            const csvData = this.objectToCSV(data)
            this.download(csvData)
        },

        printPDF(item) {
            const doc = new jsPDF({
                orientation: 'landscape'
            })
            let itemBasic = item

            var head = [                
                { title: this.$t('columns.no'), dataKey: 'no' },
                { title: this.$t('setuppayitmetype.payitemtype'), dataKey: 'payItemType' },
                { title: this.$t('setuppayitem.payitem'), dataKey: 'payItem' },
                { title: this.$t('setuppersonpayrolldirectassignment.amount'), dataKey: 'amount' },
                { title: this.$t('payrolldashboardreport.subtotal'), dataKey: 'subTotalholder' },
            ]

            let body = []

            for (var i = 0; i < itemBasic.length - 1; i++) {
                let subTotalholder = ''
                if (itemBasic[i].subTotal) subTotalholder = item[i].subTotal
                body.push({
                    no: itemBasic[i].no,
                    payItemType: itemBasic[i].payItemType,
                    payItem: itemBasic[i].payItem,
                    amount: itemBasic[i].amount,
                    subTotalholder: subTotalholder,
                })
            }
            body.push({
                no: '',
                payItemType: '',
                payItem: 'Total',
                amount: itemBasic[itemBasic.length-1].totalamt,
                subTotalholder: itemBasic[itemBasic.length-1].totalsubTotal,
            })

            doc.text(this.$t('payrolldashboardreport.payrollsummaryfor') + this.tableTitle, 10, 10)
            doc.autoTable(head, body)
            doc.save(this.$t('payrolldashboardreport.payrollsummaryfor') + this.tableTitle + '.pdf')
        },
    },

    async mounted() {
        this.loading = true;
        try {
            await this.loadPayoutControl();
            await this.loadGrossPay();
            await this.loadNetPay();
            await this.loadBasic();
            await this.loadCompanyFringe();
            await this.loadAllowance();
            await this.loadReimbursement();
            await this.loadOvertime();
            await this.loadBonus();
            await this.loadStatutoryDeductionStaff();
            await this.loadStatutoryDeductionCompany();
            await this.loadGeneralDeduction();
            await this.loadCompanyS();
            await this.loadTotalStaff();
            await this.loadDelay();
        } finally {
            this.loading = false;
        }
    }
    
}
</script>

<style scoped>
.db-stat-card {
    border-radius: 12px; padding: 14px 16px;
    display: flex; flex-direction: column; gap: 6px;
    height: 100%; border: 1px solid transparent;
}
.db-stat-label { font-size: 0.7rem; font-weight: 700; text-transform: uppercase; letter-spacing: 0.07em; opacity: 0.7; }
.db-stat-value { font-size: 1.5rem; font-weight: 800; line-height: 1.1; }
.db-stat-value-sm { font-size: 1rem; }
.db-stat-hint { font-size: 0.68rem; opacity: 0.55; margin-top: 2px; }

.db-stat-blue   { background:#EEF2FF; color:#4F6BFF; border-color:#C7D2FE; }
.db-stat-purple { background:#F5F3FF; color:#7C3AFF; border-color:#DDD6FE; }
.db-stat-green  { background:#ECFDF5; color:#059669; border-color:#A7F3D0; }
.db-stat-indigo { background:#EEF2FF; color:#4338CA; border-color:#C7D2FE; }
.db-stat-orange { background:#FFF7ED; color:#D97706; border-color:#FDE68A; }

.db-nar-row { display:flex; align-items:center; gap:6px; font-size:1.3rem; font-weight:800; margin-top:4px; }
.db-nar-sep { color:#D97706; opacity:0.4; }
.db-nar-new    { color:#92400E; }
.db-nar-active { color:#92400E; }
.db-nar-resign { color:#92400E; }

.db-amount-card {
    border-radius: 14px; padding: 0; height: 100%;
    overflow: hidden; background: #F8FAFF;
    border: 1px solid #E0E7FF;
    box-shadow: 0 2px 8px rgba(79,107,255,0.07);
    transition: transform 0.15s, box-shadow 0.15s;
}
.db-amount-card:hover { transform: translateY(-2px); box-shadow: 0 6px 18px rgba(79,107,255,0.13); }
.db-amount-card::before { content:''; display:block; height:4px; width:100%; background:linear-gradient(90deg,#4F6BFF 0%,#7C3AFF 100%); }
.db-amount-label { font-size:0.72rem; font-weight:700; text-transform:uppercase; letter-spacing:0.07em; color:#64748B; padding:12px 16px 4px; }
.db-amount-value { font-size:1.6rem; font-weight:900; line-height:1; letter-spacing:-0.02em; color:#3730A3; padding:0 16px 16px; }

.db-amount-primary,.db-amount-success,.db-amount-purple,.db-amount-teal,.db-amount-orange,.db-amount-red { background:#F8FAFF; border-color:#E0E7FF; }
.db-amount-primary .db-amount-value,.db-amount-success .db-amount-value,.db-amount-purple .db-amount-value,
.db-amount-teal .db-amount-value,.db-amount-orange .db-amount-value,.db-amount-red .db-amount-value { color:#3730A3; }
.db-amount-primary .db-amount-label,.db-amount-success .db-amount-label,.db-amount-purple .db-amount-label,
.db-amount-teal .db-amount-label,.db-amount-orange .db-amount-label,.db-amount-red .db-amount-label { color:#64748B; }

.export-icon-btn {
  display: inline-flex; align-items: center; gap: 6px;
  padding: 6px 14px; border-radius: 8px; border: none;
  font-size: 0.8rem; font-weight: 600; cursor: pointer;
  font-family: inherit; transition: all 0.15s; margin-right: 4px;
}
.export-icon-pdf { background: #FEF2F2; color: #DC2626; border: 1px solid #FECACA; }
.export-icon-pdf:hover { background: #DC2626; color: #fff; }
.export-icon-csv { background: #ECFDF5; color: #059669; border: 1px solid #A7F3D0; }
.export-icon-csv:hover { background: #059669; color: #fff; }
</style>